import { render, staticRenderFns } from "./Pricings.vue?vue&type=template&id=a0670d26"
import script from "./Pricings.vue?vue&type=script&lang=js"
export * from "./Pricings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports